import { Link, router, usePage } from '@inertiajs/react'
import { Anchor, Button, Group, Paper, Stack, Switch, Text } from '@mantine/core'
import type { SharedProps, SkillAssignmentProps } from '@/types'

type Props = {
  assignment: SkillAssignmentProps
  showTarget?: boolean
}

export default function SkillAssignmentRow({ assignment, showTarget }: Props) {
  const { csrf_token } = usePage<SharedProps>().props

  const toggleEnabled = () => {
    router.patch(`/skill_assignments/${assignment.id}`, {
      enabled: !assignment.enabled,
      authenticity_token: csrf_token || '',
    }, { preserveScroll: true })
  }

  const remove = () => {
    router.delete(`/skill_assignments/${assignment.id}`, {
      data: { authenticity_token: csrf_token || '' },
      preserveScroll: true,
    })
  }

  return (
    <Paper p="md">
      <Group justify="space-between" align="flex-start" gap="md" wrap="nowrap">
        <Stack gap={4} style={{ flex: 1 }}>
          <Group gap="xs">
            <Anchor component={Link} href={`/skills/${assignment.skill.id}`} fw={600}>
            {assignment.skill.name}
            </Anchor>
            {showTarget ? <Text c="dimmed" size="xs">{assignment.assignable_name}</Text> : null}
          </Group>
          {assignment.skill.description ? <Text c="dimmed" size="sm">{assignment.skill.description}</Text> : null}
        </Stack>

        <Group gap="sm" wrap="nowrap">
          <Switch
            checked={assignment.enabled}
            onChange={toggleEnabled}
            label={assignment.enabled ? 'On' : 'Off'}
          />
          <Button variant="subtle" color="red" onClick={remove}>
            Remove
          </Button>
        </Group>
      </Group>
    </Paper>
  )
}
